import imageImg from "../../../../../picture/slika.png";
import wordImg from "../../../../../picture/word.png";
import pdfImg from "../../../../../picture/pdf.png";
import scanImg from "../../../../../picture/scan.png";
import downloadImg from "../../../../../picture/DownloadFile.png";
import visibleImg from "../../../../../picture/Visible.png";
import deleteImg from "../../../../../picture/delete.png";
import reloadImg from "../../../../../picture/timer-language.png";
import { useState } from "react";
import { useGlobalContext } from "../../../../../Context/Context";
import ConfirmationModal from "../../../FolderDocument/ConfirmationModal";
import WarningModal from "../../WarningModal";
import axios from "axios";

const styles = {
  cell: { padding: "5px", textAlign: "center" },
  smallCell: { width: "40px", textAlign: "center", cursor: "pointer" },
  icon: { width: "30px", height: "30px" },
};

// Funkcija za formatiranje datuma koju koristiš u Važećoj tabeli
const formatDate = (val) => {
  if (!val) return "";
  const d = new Date(val);
  if (isNaN(d)) return val;
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}.${mm}.${yyyy}`;
};

const cyrillicMap = {
  "Akt o proceni rizika": "Акт о процени ризика",
  "Odluka": "Одлука",
  "Izjava": "Изјава",
  "Overena zadnja strana": "Оверена задња страна",
  "Izmena": "Измена",
  "Dopuna": "Допуна",
  "Program osposobljavanja": "Програм обуке",
  "Pravilnik": "Правилник",
  "Uputstvo za pruzanje PP": "Упутство за пружање ПП",
  "Sema ormarica": "Шема ормарића",
  "Spisak obucenih za pruzanje PP": "Списак обучених за ПП",
  "Ostala uputstva": "Остала упутства"
};

function ArhiviranaTabela({
  dokumenta,
  setDokumenta,
  moveToVazeci,
  checkedRows,
  setCheckedRows,
  isCheckedAll,
  setIsCheckedAll,
}) {
  const [selectedField, setSelectedField] = useState({ documentId: "", documentType: "" });
  const [deleteData, setDeleteData] = useState({ documentId: "", documentType: "" });
  const [isOpenWarningModal, setIsOpenWarningModal] = useState(false);

  const { dictionary, baseUrl, apiKey, loggedUser } = useGlobalContext();

  const handleSelectDocument = (documentId, documentType) => {
    setSelectedField((prev) =>
      prev.documentId === documentId && prev.documentType === documentType
        ? { documentId: "", documentType: "" }
        : { documentId, documentType }
    );
  };

  const handleCheckRow = (id) => {
    if (checkedRows.includes(id)) {
      setCheckedRows(checkedRows.filter((r) => r !== id));
    } else {
      setCheckedRows([...checkedRows, id]);
    }
  };

  const handleCheckAll = () => {
    if (isCheckedAll) setCheckedRows([]);
    else setCheckedRows(dokumenta.map((z) => z.id));
    setIsCheckedAll((prev) => !prev);
  };

  const handleOpenDelete = (id) => {
    if (selectedField.documentId === id && selectedField.documentType) {
      const doc = dokumenta.find((d) => d.id === id);
      if (!doc[selectedField.documentType]) {
        setIsOpenWarningModal(true);
        return;
      }
      setDeleteData(selectedField);
      return;
    }
    setDeleteData({ documentId: id, documentType: "" });
  };

  const handleConfirmDelete = async () => {
    const { documentId, documentType } = deleteData;
    try {
      const { data } = await axios.post(`${baseUrl}/akt/delete_document.php`, {
        api_key: apiKey,
        user_id: loggedUser.id,
        ids: [documentId],
        type: documentType,
      });

      if (data.status === 200) {
        if (documentType) {
          setDokumenta((prev) => prev.map((d) => d.id === documentId ? { ...d, [documentType]: "" } : d));
        } else {
          setDokumenta((prev) => prev.filter((d) => d.id !== documentId));
        }
      } else { alert(data.message); }
    } catch (error) { alert("Sistemska greška."); }
    finally { setDeleteData({ documentId: "", documentType: "" }); }
  };

  return (
    <>
      <table style={{ width: "100%", marginTop: "30px" }}>
        <thead>
          <tr>
            <th style={styles.smallCell}>
              <input type="checkbox" checked={isCheckedAll} onChange={handleCheckAll} style={{ width: "30px" }} />
            </th>
            <th style={styles.smallCell}><img src={wordImg} style={{ width: "30px" }} alt="w" /></th>
            <th style={styles.smallCell}><img src={pdfImg} style={{ width: "30px" }} alt="p" /></th>
            <th style={styles.smallCell}><img src={imageImg} style={{ width: "30px" }} alt="i" /></th>
            <th style={styles.smallCell}><img src={scanImg} style={{ width: "30px" }} alt="s" /></th>
            <th style={{ fontSize: "1.5em", ...styles.cell, textAlign: 'start' }}>{dictionary["tip"]}</th>
            <th style={{ fontSize: "1.5em", ...styles.cell, textAlign: 'start' }}>{dictionary["nazivDokumenta"]}</th>
            <th style={{ fontSize: "1.5em", ...styles.cell }}>{dictionary["dodato"]}</th>
            <th style={styles.smallCell}></th><th style={styles.smallCell}></th><th style={styles.smallCell}></th><th style={styles.smallCell}></th>
          </tr>
        </thead>
        <tbody>
          {dokumenta.map((dokument) => {
            // Mapiranje polja da odgovaraju bazi i Važećoj tabeli
            const vrstaPrikaz = dokument.vrsta || "";
            const nazivPrikaz = dokument.naziv || "Bez naziva";
            // Koristimo formatDate kao u Važećoj tabeli
            const datumPrikaz = formatDate(dokument.datum || dokument.created_at);

            return (
              <tr key={dokument.id}>
                <td style={styles.cell}>
                  <input type="checkbox" checked={checkedRows.includes(dokument.id)} onChange={() => handleCheckRow(dokument.id)} style={{ width: "30px" }} />
                </td>
                {["word", "pdf", "image", "scan"].map((type) => (
                  <td key={type} onClick={() => handleSelectDocument(dokument.id, type)}
                    style={{ ...styles.smallCell, border: selectedField.documentId === dokument.id && selectedField.documentType === type ? "2px solid black" : "" }}>
                    <div style={{ backgroundColor: dokument[type] || "transparent", width: "25px", height: "25px", margin: "auto" }}></div>
                  </td>
                ))}
                
                <td style={{ fontSize: "1.3em", color: "#666", padding: "5px", textAlign: "start" }}>
                  {cyrillicMap[vrstaPrikaz] || vrstaPrikaz}
                </td>
                
                <td style={{ fontSize: "1.5em", fontWeight: "bold", padding: "5px", textAlign: "start" }}>
                  {nazivPrikaz}
                </td>

                <td style={{ fontSize: "1.3em", fontWeight: "bold", ...styles.cell }}>
                  {datumPrikaz}
                </td>
                
                <td style={styles.smallCell}><img src={visibleImg} style={{ width: "30px" }} alt="v" /></td>
                <td style={styles.smallCell}><img src={downloadImg} style={{ width: "25px" }} alt="d" /></td>
                <td onClick={() => handleOpenDelete(dokument.id)} style={styles.smallCell}><img src={deleteImg} style={{ width: "25px" }} alt="x" /></td>
                <td onClick={() => moveToVazeci(dokument)} style={styles.smallCell}><img src={reloadImg} style={{ width: "25px" }} alt="r" /></td>
              </tr>
            );
          })}
        </tbody>
      </table>

      {deleteData.documentId && (
        <ConfirmationModal
          handleConfirm={handleConfirmDelete}
          text={deleteData.documentType 
            ? `Da li ste sigurni da želite da obrišete ${deleteData.documentType} verziju?` 
            : dictionary["confirmDeleteDocumentAllVersions"]}
          handleCancel={() => setDeleteData({ documentId: "", documentType: "" })}
        />
      )}

      {isOpenWarningModal && (
        <WarningModal text={dictionary["nepostojecaVerzija"]} handleCancel={() => setIsOpenWarningModal(false)} />
      )}
    </>
  );
}

export default ArhiviranaTabela;